import React, { ChangeEvent, FC, useEffect, useState } from "react";
import { useTranslate } from "../../../hooks/LanguageProvider";

interface StationaryDurationAlarmProps {
  alarm: any;
  alarmType: "StationaryWithEngineOn" | "StationaryWithEngineOff";
  onChange: (newMetrics: any) => void;
}

const StationaryDurationAlarm: FC<StationaryDurationAlarmProps> = ({
  alarm,
  alarmType,
  onChange,
}) => {
  const { translate } = useTranslate();
  const [duration, setDuration] = useState<string>("60");

  const durationOptions = [
    { label: "1 min", value: "60" },
    { label: "2 min", value: "120" },
    { label: "5 min", value: "300" },
    { label: "10 min", value: "600" },
  ];

  useEffect(() => {
    setDuration(String(alarm?.duration ?? "60"));
  }, [alarm]);

  const updateDuration = (value: string) => {
    setDuration(value);
    onChange({
      ...alarm,
      type: alarmType,
      duration: value === "" ? "" : Number(value),
    });
  };

  const handleDurationChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;

    if (value === "") {
      updateDuration("");
      return;
    }

    const numericValue = Number(value);
    if (!Number.isNaN(numericValue) && numericValue >= 30 && numericValue <= 86400) {
      updateDuration(value);
    }
  };

  const handlePresetChange = (event: ChangeEvent<HTMLSelectElement>) => {
    updateDuration(event.target.value);
  };

  return (
    <div className="d-flex align-items-center flex-wrap" style={{ gap: "8px" }}>
      <div className="input-group input-group-sm" style={{ width: "360px" }}>
        <span className="input-group-text">{translate("Parking duration")}</span>
        <input
          className="form-control"
          name="stationary_duration"
          value={duration}
          type="number"
          min={30}
          max={86400}
          placeholder="60"
          onChange={handleDurationChange}
        />
        <span className="input-group-text">sec</span>
      </div>
      <select
        className="form-select form-select-sm"
        style={{ width: "120px" }}
        value={duration}
        onChange={handlePresetChange}
      >
        {durationOptions.map((item) => (
          <option key={item.value} value={item.value}>
            {item.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default StationaryDurationAlarm;
